import { gql } from 'apollo-boost';

// eslint-disable-next-line import/prefer-default-export
export const GET_ALL_DEALERS = gql`
  query dealersByMarket($market: Market!) {
    dealersByMarket(market: $market) {
      dealers {
        name
        kvpsId
        latitude
        longitude
        street
        city
        zipCode
        region
        houseNumber
        email
        phoneURL
        phone
      }
    }
  }
`;
